exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  max-height: 500px !important;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/const/shared-devices/shared-devices.component.scss
// module id = ../../../../../src/app/const/shared-devices/shared-devices.component.scss
// module chunks = main